import module from 'cheques/module.js'
import template from './template.html'

class ChequesChequerasComponent {
  constructor (Cheques, $notify) {
    this.Cheques = Cheques
    this.$notify = $notify
  }

  $onInit () {
    this.$promise = this.Cheques.get(false)
      .then((response) => (this.data = response.data))
  }

  editarChequera (chequera) {
    this.chequera = chequera
  }

  cargarCuentas () {
    this.$promise = this.Cheques.get(this.chequera.id_empresa, this.chequera.id_cuenta)
      .then((response) => (this.data = response.data))
  }

  cancelarGuardarChequera () {
    this.chequera = {
      folio: '',
      consecutivo_inicial: '',
      consecutivo_final: '',
      status: '',
    }
  }

  guardarChequera () {
    this.$promise = this.Cheques.post(this.chequera)
      .then((response) => {
        if (response.data !== true) {
          this.$notify.error(response.data)
        } else {
          this.$notify.success('Guardado.')
          this.chequera = {}
        }

        this.cargarCuentas()
      })
  }
}

module.component('chequesChequeras', {
  controller: ChequesChequerasComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/cheques/components/chequeras/component.js